<template>
  <ArtisanGrid :metaData="value"></ArtisanGrid>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          columns: [],
        };
      },
    },
  },
};
</script>

<style>
</style>